class VariantPicker extends HTMLElement {
  label: HTMLLabelElement | null = null;

  connectedCallback() {
    this.label = this.querySelector('label');

    if (!this.label) return;

    this.label.addEventListener('keypress', (event) => {
      const keyboardEvent = event as KeyboardEvent;
      if (keyboardEvent.code === 'Enter' || keyboardEvent.code === 'Space') {
        event.preventDefault();
        // clicking the label will trigger the target input change
        (event.currentTarget as HTMLLabelElement)?.click();
      }
    });
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}
